import "@/App.css";
import "@/design-fixes.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Inbox from "@/pages/Inbox";
import CalendarView from "@/pages/CalendarView";
import Tasks from "@/pages/Tasks";
import Growth from "@/pages/Growth";
import Reminders from "@/pages/Reminders";
import Contacts from "@/pages/Contacts";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import AcceptInvite from "@/pages/AcceptInvite";
import Collaboration from "@/pages/Collaboration";
import Notifications from "@/pages/Notifications";
import Approvals from "@/pages/Approvals";
import { AuthGate } from "@/components/AuthGate";
import { InstallApp } from "@/components/InstallApp";

function PrivateApp() {
  return (
    <AuthGate>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/calendar" element={<CalendarView />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/growth" element={<Growth />} />
          <Route path="/reminders" element={<Reminders />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/approvals" element={<Approvals />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/collaboration" element={<Collaboration />} />
          <Route path="/notifications" element={<Notifications />} />
        </Routes>
      </Layout>
    </AuthGate>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <InstallApp />
        <Routes>
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="*" element={<PrivateApp />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
